<template>
  <div class="mt-2">
    <ClientList />
  </div>
</template>

<script setup lang="ts">
import ClientList from "@/views/ClientList.vue";
</script>
